'use strict';
import { getFrontendProperties } from './Config';

let pageTitleBase = '';

export default {
  // User is notified when contact information
  // has not been updated in specified time (moment syntax)
  contactReminderInterval: () => [
    getFrontendProperties().contactReminderIntervalAmount,
    getFrontendProperties().contactReminderIntervalUnit,
  ],
  // Functions for setting and getting the page title in it's state
  // when page was loaded. This is done for the purpose of appending
  // page titles to the original so that "Minun hoitoni" page title would be
  // something like
  // Omatays - Etusivu | Minun hoitoni
  setPageTitleBase: (title) => {
    pageTitleBase = title;
  },
  getPageTitleBase: () => {
    return pageTitleBase;
  },
  // Function for setting the skip to content link friendly for react
  // hashrouter. Since hashrouter is used, there is no use for anchor links.
  // That is why we have to use javascript focus. We also want to focus on
  // the portlet content so the 'role' attribute is moved to portlet.
  // todo: this should be rather done in theme where "skip to content" button
  // is created
  alterSkipToContent: () => {
    // get "skip to content" element from liferay
    let skipToContentElement = document.getElementById('skip-to-content');
    skipToContentElement.setAttribute('tabindex', '1');

    // get main element of liferay
    let oldMainElement = document.getElementById('main-content');
    // get main element of portlet
    let newMainElement = document.getElementById('ot-mainview');

    // remove 'main' role from old element
    oldMainElement.removeAttribute('role');
    // add 'main' role to new element
    newMainElement.setAttribute('role', 'main');
    newMainElement.setAttribute('tabindex', '-1');

    skipToContentElement.onclick = (event) => {
      // bypass click handler of old 'skip to content'
      event.preventDefault();
      newMainElement.focus();
    };
  },
};
